<template>
    <div class="msg-content" :class="type">
        <h1>
            <i :class="typeItem.icon"></i>
            <slot></slot>
        </h1>
    </div>
</template>

<script>
export default {
    mixins: [ ],
    components: {},
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            typeObj: {
                success: {
                    icon: 'el-icon-circle-check'
                },
                error: {
                    icon: 'el-icon-circle-close'
                },
                warning: {
                    icon: 'el-icon-warning-outline'
                }
            }
        }
    },
    computed: {
        typeItem() {
            return this.typeObj[this.type] || {};
        }
    },
    methods: {

    },
    created() {

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
@import '@css/var.scss';

.msg-content{ text-align:center; color:#303133; max-width:800px; margin:1em auto; border:1px solid; border-radius:4px; padding:1em; box-sizing:border-box;
    &.success{color:$successColor; border-color:$successColor; background-color:$successColor8;}
    &.error{color:$dangerColor;  border-color:$dangerColor; background-color:$dangerColor8;}
    &.warning{color:$warningColor;  border-color:$warningColor; background-color:$warningColor8;}
}

</style>
